import React from 'react';
import HeroSection from '../components/home/HeroSection';
import StepsSection from '../components/home/StepsSection';
import RTOSection from '../components/home/RTOSection';
import VideoSection from '../components/home/VideoSection';
import WhyChooseSection from '../components/home/WhyChooseSection';
import CategoriesSection from '../components/home/CategoriesSection';
import ContactSection from '../components/home/ContactSection';
import DisclaimerSection from '../components/home/DisclaimerSection';

const HomePage = () => {
  return (
    <>
      <HeroSection />
      <StepsSection />
      <RTOSection />
      <VideoSection />
      <WhyChooseSection />
      <CategoriesSection />
      <ContactSection />
      <DisclaimerSection />
    </>
  );
};

export default HomePage; 